<template>
    <div id="login" :style="background">
        <div class="login-wrapper" style="background: #ffffff;border-style: solid; border-radius: 5px; border-width: 2px">
            <div class="title">Brain Science Lab</div>
            <el-form class="login-form" :model="form" @submit.native.prevent="verify">
                <el-form-item>
                    <!-- username -->
                    <el-input v-model="form.username" :placeholder="$t('login.account')" auto-complete='off' />
                    <span class="input-icon prepend-icon">
                        <i class="el-icon-my-user"></i>
                    </span>
                </el-form-item>
                <el-form-item>
                    <!-- password -->
                    <el-input v-model="form.password" :placeholder="$t('login.password')" auto-complete='off' :type="pwdWatch ? 'text' : 'password'" />
                    <span class="input-icon prepend-icon">
                        <i class="el-icon-my-lock"></i>
                    </span>
                    <span class="input-icon append-icon" @click="pwdWatch = !pwdWatch">
                        <i :class="pwdWatch ? 'el-icon-my-openEye' : 'el-icon-my-closeEye'"></i>
                    </span>
                </el-form-item>
                <!-- submit -->
                <div align="end"><el-button native-type="submit" round>{{ $t('login.login') }}</el-button><el-button @click="signup" type="primary" round>{{ $t('login.signup') }}</el-button></div>
            </el-form>
        </div>

    </div>
</template>
<script>
/* eslint-disable */

export default {
    name: 'login',
    data() {
        return {
            background: {
                backgroundImage: 'url(' + require('@/assets/img/background.jpg') + ')',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                opacity: 0.7
            },
            form: {
                username: '',
                password: ''
            },
            pwdWatch: false
        }
    },
    methods: {
        verify() {
            if (!this.form.username) {
                this.$message.error('请输入账号')
            } else if (!this.form.password) {
                this.$message.error('请输入密码')
            } else {
                this.login()
            }
        },
        login() {
            document.getElementById("account").value = this.form.username
            document.getElementById("password").value = this.form.password
            document.getElementById("login-btn").click()
        },
        signup() {
            this.$router.push('/sso/v1/signup')
        }
    },
    mounted(){
        if(this.$route.query.error !== undefined) this.$message.error('登陆失败')
    }
}
</script>
<style lang='stylus'>
#login {
    position: relative;
    width: 100%;
    height: 95vh;
    /*background: #464c5b;*/
    background: #ffffff;
    overflow: hidden;
    .login-wrapper {
        position: absolute;
        width: 520px;
        left: 0;
        right: 0;
        margin: 150px auto;
        padding: 30px;
        .title {
            display: block;
            font-size: 26px;
            /*font-weight: 400;*/
            /*color: #eee;*/
            color: #3a8ee6;
            margin: 0 auto 50px;
            text-align: center;
            font-weight: bold;
        }
        .login-form {
            .el-input__inner {
                padding: 0 36px 0 40px;
                height: 44px;
                line-height: 44px;
            }
            .input-icon {
                position: absolute;
                top: 0;
                font-size: 16px;
                user-select: none;
                cursor: pointer;
                padding: 0 10px;
                text-align: center;
                height: 100%;
                display: flex;
                align-items: center;
                &.prepend-icon {
                    left: 0;
                }
                &.append-icon {
                    right: 0;
                }
            }
            .login_btn {
                input {
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                }
                &:hover {
                    input {
                        color: $blackColor;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/login.vue